const WORDS = [
  "Compassion",
  "Clarity",
  "Neurodiversity",
  "Evidence-based",
  "Understanding",
  "Growth",
  "Warmth",
  "Resilience",
];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-border bg-prism-sand/60 py-8 overflow-hidden"
      aria-hidden
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-3xl sm:text-4xl font-light text-text-secondary px-8">
              {w}
            </span>
            <span className="h-2 w-2 rounded-full prism-line" />
          </span>
        ))}
      </div>
    </section>
  );
};
